import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const Transportation = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Transporte'}
            horizontal={true}
            subtitles={chartData?.transportation?.map((item) => item.description)}
            values={chartData?.transportation?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
